module.exports = __webpack_public_path__ + "static/waller_welt_steg-min.dd7479c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/converted/waller_welt_steg-min.jpg
// module id = 1128
// module chunks = 35783957827783